import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Department {
  name: string;
  api_token: string;
}

export interface DepartmentDetaiInfor {
  errors: unknown;
  department: Department;
  isAuthenticated: boolean;
}

@Module
export default class DepartmentDetail
  extends VuexModule
  implements DepartmentDetaiInfor
{
  errors = {};
  department = {} as Department;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get DepartmentDetail() {
    return this.departmentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.DEPARTMENT_DETAIL_DATA](Department) {
    this.departmentDetailData = Department;
  }
  @Action
  [Actions.DEPARTMENT_DETAIL](payload) {
    return ApiService.getDataDetail("/department", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.DEPARTMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
